import { Spacing } from "../../../foundations/spacing.es.js";
const accordionDetailsStyleOverrides = {
  root: {
    paddingBottom: Spacing["1500"]
  }
};
export {
  accordionDetailsStyleOverrides
};
//# sourceMappingURL=accordion-details.es.js.map
